import { z } from "zod/v4";

import { ShopifyCountryList, ShopifyCurrencyList } from "../../shopify";

export const ExperienceExclusionList = [
  "Page Target Exclude",
  "Preview Experience",
  "Force Exclude Experience",
  "Previously Excluded",
  "Wholesale",
] as const;

export const ExperienceExclusionSchema = z.union([
  z.enum(ExperienceExclusionList),
  z.enum(ShopifyCountryList),
  z.enum(ShopifyCurrencyList),
]);
export type ExperienceExclusionType = z.infer<typeof ExperienceExclusionSchema>;

export type ExperienceDirectiveKey =
  | "EXCLUDED"
  | "UNASSIGNED"
  | "PERMA_EXCLUDED";
export type ExperienceDirectiveTemplate<T extends string> = `_${T}`;
